import { useState } from 'react';
import { WIDGET_COLORS } from '../../constants/colors';
import {
  formatPoints,
  formatContactMonth,
} from '../../utils/formatSavingsPoints';
import type { SavingsPointsData } from '../../hooks/useGetSavingsPoints';
import { WidgetCardHeader } from '../widgetCardHeader';
import { WidgetDivider } from '../widgetDivider';
import { ProgressItem } from '../progressItem';
import { StatRow } from '../statRow';
import { WidgetNotice } from '../widgetNotice';
import { InfoButton } from '../infoButton';
import { CongratsModal } from '../congratsModal';

type Props = { data: SavingsPointsData };

export function ReadyInQueue({ data }: Props) {
  const [congratsOpen, setCongratsOpen] = useState(false);

  return (
    <>
      <WidgetCardHeader
        variant="success"
        badgeText="Active"
        description="You are now eligible to apply for Pfida's home finance!"
        descriptionColor={WIDGET_COLORS.primary}
        descriptionWeight={500}
      />

      <WidgetDivider />

      <ProgressItem
        label="Community Points"
        value={
          <span className="font-bold" style={{ color: WIDGET_COLORS.green.text }}>
            ✓ 100%
          </span>
        }
        barPercent={100}
        segments={[{ flex: 1, color: WIDGET_COLORS.green.bar }]}
      />

      <ProgressItem
        label="Down Payment (GYS Home balance)"
        value={
          <span className="font-bold" style={{ color: WIDGET_COLORS.green.text }}>
            ✓ 100%
          </span>
        }
        barPercent={100}
        segments={[{ flex: 1, color: WIDGET_COLORS.green.bar }]}
      />

      <StatRow
        bg={WIDGET_COLORS.green.bg}
        dividerColor={WIDGET_COLORS.green.divider}
        left={{
          value: `${formatPoints(data.savings_points_earned)} pts`,
          valueColor: WIDGET_COLORS.green.text,
          label: 'Community Points',
        }}
        right={{
          value: data.contact_month ? formatContactMonth(data.contact_month) : '-',
          valueColor: WIDGET_COLORS.green.text,
          label: (
            <span className="inline-flex items-center uppercase">
              Estimated Reach-out
              <InfoButton
                onClick={() => setCongratsOpen(true)}
                style={{ borderColor: WIDGET_COLORS.green.text, color: WIDGET_COLORS.green.text }}
              />
            </span>
          ),
        }}
      />

      <WidgetNotice variant="success" icon="check-circle">
        Congratulations! You have met all the criteria to apply for home finance with Pfida. And
        while you have been saving, you have helped multiple families into their forever homes. We
        will be in contact in the coming months about your next steps.
      </WidgetNotice>

      <CongratsModal open={congratsOpen} onOpenChange={setCongratsOpen} />
    </>
  );
}
